import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BottleType } from 'src/pages/Bottle/Bottles.types'
import { useActiveFilters } from 'src/zustand/stores/filters.store'

import { calculateCountdown } from '../../../utils/calculateCountdown'

export const useFilter = () => {
  const [filteredBottles, setFilteredBottles] = useState<BottleType[]>([])
  const [firstVersionOfList, setFirstVersionOfList] = useState<BottleType[]>([])
  const { t } = useTranslation()

  const { typesOfDeposits, amountsOfDeposits, numbersOfParticipants, typesOfBottles } = useActiveFilters(
    (state) => state.filters,
  )

  const passListOfBottles = useCallback((listOfBottles: BottleType[]) => {
    setFilteredBottles(listOfBottles)
    setFirstVersionOfList(listOfBottles)
  }, [])

  const filter = useCallback(() => {
    let result = [...firstVersionOfList]

    if (typesOfDeposits.length > 0) {
      result = result.filter((bottle: BottleType) =>
        typesOfDeposits.some((type) => {
          console.log('type: ', type)
          if (type === t('filters.fixed')) return bottle.type?.includes('FIXED')
          if (type === t('filters.any')) return bottle.type?.includes('ANY')
          return false
        }),
      )
    }

    if (amountsOfDeposits.length > 0) {
      result = result.filter(
        (bottle: BottleType) =>
          amountsOfDeposits[0] <= (bottle.entry_sum || 0) && (bottle.entry_sum || 0) <= amountsOfDeposits[1],
      )
    }

    if (numbersOfParticipants.length > 0) {
      result = result.filter((bottle) =>
        numbersOfParticipants.some((stringOfNumberOfParticipants) => {
          const partitionedArray = stringOfNumberOfParticipants.split(' ')
          const formattedNumber = parseInt(partitionedArray[partitionedArray.length - 1], 10)
          return formattedNumber !== 1000
            ? bottle.participants_count || 0 < formattedNumber
            : bottle.participants_count || 0 > formattedNumber
        }),
      )
    }

    if (typesOfBottles.length > 0) {
      result = result.filter((bottle) =>
        typesOfBottles.some((type) => {
          if (type === t('filters.active')) {
            return (
              calculateCountdown(bottle.available_until).time !== '00:00:00' &&
              calculateCountdown(bottle.available_until, bottle.start_date).message !== 'Start is expected'
            )
          }

          if (type === t('filters.planned')) {
            return calculateCountdown(bottle.available_until, bottle.start_date).message === 'Start is expected'
          }

          return false
        }),
      )
    }

    setFilteredBottles(result)
  }, [typesOfDeposits, amountsOfDeposits, numbersOfParticipants, typesOfBottles, firstVersionOfList])

  return { filteredBottles, passListOfBottles, filter }
}
